/**
 * ============================================================
 * KML Style Parser
 * ============================================================
 */

class KMLStyleParser {
    parse(xml) {
        const styles = new Map();

        const styleMaps = new Map();

        // =====================================================
        // Style
        // =====================================================

        xml.querySelectorAll("Style").forEach((styleNode) => {
            const id = styleNode.getAttribute("id");

            if (!id) return;

            styles.set(id, this.parseStyle(styleNode));
        });

        // =====================================================
        // StyleMap
        // =====================================================

        xml.querySelectorAll("StyleMap").forEach((mapNode) => {
            const id = mapNode.getAttribute("id");

            if (!id) return;

            let normal = null;

            mapNode.querySelectorAll("Pair").forEach((pair) => {
                const key = pair.querySelector("key")?.textContent.trim();

                const url = pair.querySelector("styleUrl")?.textContent.trim();

                if (key === "normal") {
                    normal = url.replace("#", "");
                }
            });

            if (normal) {
                styleMaps.set(id, normal);
            }
        });

        // =====================================================
        // Resolve StyleMap
        // =====================================================

        styleMaps.forEach((styleId, mapId) => {
            if (styles.has(styleId)) {
                styles.set(mapId, styles.get(styleId));
            }
        });

        return styles;
    }

    parseStyle(node) {
        return {
            line: this.parseLineStyle(node),

            polygon: this.parsePolyStyle(node),

            icon: this.parseIconStyle(node),
        };
    }

    // =====================================================
    // Line
    // =====================================================

    parseLineStyle(node) {
        const line = node.querySelector("LineStyle");

        if (!line) return null;

        return {
            color: this.kmlColor(line.querySelector("color")?.textContent),

            width: Number(line.querySelector("width")?.textContent ?? 2),
        };
    }

    // =====================================================
    // Polygon
    // =====================================================

    parsePolyStyle(node) {
        const poly = node.querySelector("PolyStyle");

        if (!poly) return null;

        return {
            color: this.kmlColor(poly.querySelector("color")?.textContent),

            fill: poly.querySelector("fill")?.textContent !== "0",

            outline: poly.querySelector("outline")?.textContent !== "0",
        };
    }

    // =====================================================
    // Icon
    // =====================================================

    parseIconStyle(node) {
        const icon = node.querySelector("IconStyle");

        if (!icon) return null;

        return {
            scale: Number(icon.querySelector("scale")?.textContent ?? 1),

            href: icon.querySelector("href")?.textContent ?? "",
        };
    }

    // =====================================================
    // KML Color (AABBGGRR)
    // =====================================================

    kmlColor(value) {
        if (!value || value.length !== 8) {
            return {
                color: "#3388ff",

                opacity: 1,
            };
        }

        const aa = parseInt(value.substring(0, 2), 16);

        const bb = value.substring(2, 4);

        const gg = value.substring(4, 6);

        const rr = value.substring(6, 8);

        return {
            color: `#${rr}${gg}${bb}`,

            opacity: aa / 255,
        };
    }
}

export default new KMLStyleParser();
